import React from "react";
import SpecialistAssignmentBoard from "./SpecialistAssignmentBoard";
import FlowEngineGlobalGate from "../specialist-flow-engine/FlowEngineGlobalGate";

const SpecialistManagerSelectionScreen = () => {
  return (
    <FlowEngineGlobalGate>
      <SpecialistAssignmentBoard
        roleKey="manager"
        titleKey="specialist.selection.manager.title"
        defaultTitle="Bandeja del Gestor"
      />
    </FlowEngineGlobalGate>
  );
};

export default SpecialistManagerSelectionScreen;



